import {
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const cancelWorkOrder = {
  name: "cancelWorkOrder" as const,
  input: z.object({
    workOrderId: z.string(),
    putaway: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          storageLocationId: storageLocationIdFormat.schema,
        }),
      )
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
